package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateList
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.models.ChatBotMessage
import org.example.zone360.models.DashboardChatState
import org.example.zone360.models.GetClubPerformanceData
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.dashboard.dashboardAssistantAI.DashboardChatbot
import org.example.zone360.pages.dashboard.dashboardAssistantAI.ResponsiveDashboardChatbot
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.Strings
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

@Composable
fun DashboardChatOverlay(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    isChatOpen: Boolean,
    onDismiss: () -> Unit,
    userId: String,
    coachProfile: GetSingleCoachData?,
    selectedDataType: SelectedData,
    selectedLanguage: SelectedLanguage,
    allSessions: List<GetSessionsData>,
    showOverlay: Boolean,
    onShowOverlayChange: (Boolean) -> Unit,
    subscriptionPopup: (Boolean) -> Unit,
    coachPlayerList: List<GetPlayerData>,
    performanceResponse: GetClubPerformanceData,
    chatMessages: DashboardChatState
) {

    Box(
        modifier = Modifier
            .fillMaxSize()
            .styleModifier {
                property(
                    "pointer-events",
                    if (isChatOpen) "auto" else "none"
                )
            }
    ) {
        // Backdrop
        Box(
            modifier = Modifier
                .position(Position.Fixed)
                .top(0.px)
                .left(0.px)
                .width(100.vw)
                .height(100.vh)
                .zIndex(998)
                .backgroundColor(rgba(0, 0, 0, 0.5))
                .opacity(if (isChatOpen) 1f else 0f)
                .styleModifier {
                    property("pointer-events", if (isChatOpen) "auto" else "none")
                }
                .transition(
                    Transition.of(
                        TransitionProperty.All,
                        300.ms,
                        AnimationTimingFunction.EaseInOut
                    )
                )
                .onClick {
                   onDismiss()
                }
        )

        // Chatbot
        Box(
            modifier = Modifier
                .position(Position.Fixed)
                .top(50.percent)
                .left(50.percent)
                .width(if (breakpoint < Breakpoint.MD) 95.vw else 80.vw)
//                .height(if (breakpoint < Breakpoint.MD) 95.vh else 50.vh)
                .zIndex(999999)
                .transform {
                    translate((-50).percent, (-50).percent)
                    translateY(if (isChatOpen) 0.px else 30.px)
                    scale(if (isChatOpen) 1f else 0.96f)
                }
                .opacity(if (isChatOpen) 1f else 0f)
                .styleModifier {
                    property("pointer-events", if (isChatOpen) "auto" else "none")
                }
                .transition(
                    Transition.of(
                        TransitionProperty.All,
                        300.ms,
                        AnimationTimingFunction.EaseInOut
                    )
                )
                .onClick {
                    it.stopPropagation()    // <-- Prevent backdrop click
                }
        ) {

            Box(
                modifier = Modifier
                    .fillMaxSize()
//                        .overflow(Overflow.Hidden)
                    .borderRadius(
                        if (breakpoint < Breakpoint.MD) 0.px else 12.px
                    )
            ) {

                if (breakpoint < Breakpoint.MD &&
                    AppGlobal.userData.role == Strings.ADMIN
                ) {

                    ResponsiveDashboardChatbot(
                        onDismiss = { onDismiss ()},
                        breakpoint = breakpoint,
                        sitePalette = sitePalette,
                        userId = AppGlobal.userData.uid,
                        getCoachInfo = coachProfile ?: GetSingleCoachData(),
                        selectedSessionType = selectedDataType,
                        selectedLanguage = selectedLanguage,
                        sessionList = allSessions,
                        showOverlay = showOverlay,
                        onShowOverlayChange = onShowOverlayChange,
                        subscriptionPopup = subscriptionPopup,
                        playersList = coachPlayerList,
                        performanceResponse = performanceResponse,
                    )

                } else {

                    DashboardChatbot(
                        onDismiss = { onDismiss ()},
                        isChatOpen = true,
                        onExpandToggle = { onDismiss()},
                        breakpoint = breakpoint,
                        sitePalette = sitePalette,
                        userId = AppGlobal.userData.uid,
                        getCoachInfo = coachProfile ?: GetSingleCoachData(),
                        selectedSessionType = selectedDataType,
                        selectedLanguage = selectedLanguage,
                        sessionList = allSessions,
                        showOverlay = showOverlay,
                        onShowOverlayChange = onShowOverlayChange,
                        subscriptionPopup = subscriptionPopup,
                        playersList = coachPlayerList,
                        performanceResponse = performanceResponse,
                        scrollContainerId = Res.Id.popupScrollContainerDashboard,
                        messageInputId = Res.Id.popupMessageInput,
                        chatState = chatMessages

                    )
                }
            }
        }
    }

}